var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStripe(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 128,
    viewBox: "0 0 128 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M74.5385 48.8C62.9545 44.5013 56.6398 41.1947 56.6398 35.952C56.6398 31.52 60.2825 28.992 66.7785 28.992C78.6558 28.992 90.8585 33.568 99.2585 37.6907L104.005 8.38933C97.3438 5.2 83.7171 0 64.8798 0C51.5571 0 40.4745 3.488 32.5545 9.984C24.3198 16.784 20.0371 26.624 20.0371 38.496C20.0371 60.0373 33.1945 69.216 54.5758 76.9973C68.3625 81.904 72.9491 85.392 72.9491 90.7733C72.9491 96 68.4691 99.0133 60.3945 99.0133C50.3945 99.0133 33.9145 94.1013 23.1145 87.7653L18.3145 117.392C27.5998 122.613 44.7198 128 62.4745 128C76.5598 128 88.3038 124.672 96.2238 118.331C105.098 111.371 109.69 101.072 109.69 87.76C109.69 65.744 96.2291 56.5547 74.5225 48.8H74.5385Z",
    fill: "#635BFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStripe);
export default __webpack_public_path__ + "static/media/stripe.e8888e76731b7273aab06add049108e7.svg";
export { ForwardRef as ReactComponent };